import { FC } from "react";
import { Button } from "@mui/material";

interface FormActionsProps {
  onSave: () => void;
  onDiscard: () => void;
  isLoading?: boolean;
  hasChanges?: boolean;
}

const FormActions: FC<FormActionsProps> = ({
  onSave,
  onDiscard,
  isLoading = false,
  hasChanges = true,
}) => {
  return (
    <div className="d-flex gap-2 mt-4">
      <Button
        variant="contained"
        color="primary"
        onClick={onSave}
        disabled={isLoading || !hasChanges}
      >
        {isLoading ? "Salvando..." : "Salvar"}
      </Button>
      <Button
        variant="outlined"
        color="secondary"
        onClick={onDiscard}
        disabled={isLoading}
      >
        Descartar
      </Button>
    </div>
  );
};

export default FormActions;
